import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import useFaqs from "../Hooks/useFaqs";
import ComFaqs from '../components/ComFaqs';


const Faqs = () =>{
    const { Faqs, loading, error } = useFaqs();
    if(loading){
      return (
          <div className="mx-auto md:px-8 w-full min-h-full"> Loading </div>
      );
    }
    if (error) return <p>Error: {error}</p>;

    return (
    <div>
      <ComFaqs dtfaqs={Faqs} />
    </div>
    );

}
export default Faqs;